import React from 'react';
import {InputNumber, Space, Typography} from 'antd';

const LevelRangeCondition = ({params, onChange}) => {
    return (
        <Space>
            <Typography.Text>레벨</Typography.Text>
            <InputNumber
                min={1}
                value={params.min}
                onChange={v => onChange({...params, min: v})}
                placeholder="최소"
                style={{width: 80}}
            />
            <Typography.Text>~</Typography.Text>
            <InputNumber
                min={1}
                value={params.max}
                onChange={v => onChange({...params, max: v})}
                placeholder="최대"
                style={{width: 80}}
            />
        </Space>
    );
};

export default LevelRangeCondition;